<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Global Discount Pricing</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Global Discount Pricing</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="GlobalDiscountPricing">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'GlobalDiscountPricingList'}"><i class="fas fa-list"></i>
                  List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Product Type</label>
                    <!--                    <select class="form-control" style="width: 100%;" name="product_type"
                                                v-model="value.product_type" id="product_type" readonly>
                                          <option value="course">course</option>
                                          <option value="bundle">bundle</option>
                                        </select>-->
                    <input type="text" id="product_type" name="product_type"
                           v-bind:class="{'has-error' : errors.has('product_type')}"
                           v-validate="'required'"
                           v-model="value.product_type" class="form-control product_type"
                           placeholder="Priority" disabled>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Currency</label>
                    <!--<select class="form-control" style="width: 100%;"
                            name="currency" v-model="value.currency" id="currency">
                      <option value="BDT">BDT</option>
                      <option value="INR">INR</option>
                    </select>-->
                    <input type="text" id="currency" name="currency"
                           v-bind:class="{'has-error' : errors.has('currency')}"
                           v-validate="'required'"
                           v-model="value.currency" class="form-control currency"
                           placeholder="Currency" disabled>
                  </div>

                  <div class="form-group ">
                    <label class="control-label">Platform</label>
                    <!--                    <select class="form-control" style="width: 100%;"
                                                name="platform" v-model="value.platform" id="platform">
                                          <option value="web">web</option>
                                          <option value="mobile">mobile</option>
                                        </select>-->
                    <input type="text" id="platform" name="platform"
                           v-bind:class="{'has-error' : errors.has('platform')}"
                           v-validate="'required'"
                           v-model="value.platform" class="form-control platform"
                           placeholder="Platform" disabled>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Rating Type</label>
                    <select class="form-control" style="width: 100%;" name="rating_type_id"
                            v-model="value.rating_type_id" id="rating_type_id" readonly required>
                      <option value="2" selected>Discount</option>
                    </select>
                  </div>

                  <div class="form-group required">
                    <!--                    <label class="control-label">Priority</label>-->
                    <input type="text" id="priority" name="priority"
                           v-bind:class="{'has-error' : errors.has('priority')}"
                           v-validate="'required'"
                           v-model="value.priority" class="form-control priority"
                           placeholder="Priority" hidden>
                    <div class="help text-danger" v-show="errors.has('priority')">
                      {{ errors.first("priority") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Rate</label>
                    <input type="text" id="rate" name="rate" v-model="value.rate" class="form-control rate"
                           placeholder="Rate" required>
                    <small class="form-text text-muted"><i class="fa fa-info-circle"></i>
                      &nbsp;This value will be used as percentage(%) for discount configuration.
                    </small>
                    <div class="help text-danger" v-show="errors.has('rate')">
                      {{ errors.first("rate") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Activation Start</label>
                    <div class="clearfix"></div>
                    <date-picker type="date" input-class="form-control"
                                 name="activation_start" v-model="value.activation_start" lang="en"
                                 format="YYYY-MM-DD" value-type="YYYY-MM-DD"
                                 v-bind:class="{'has-error' : errors.has('activation_start')}"
                                 placeholder="Activation Start"/>
                    <div class="help text-danger" v-show="errors.has('activation_start')">
                      {{ errors.first("activation_start") }}
                    </div>
                  </div>

                  <div class="form-group required">
                    <label class="control-label">Activation End</label>
                    <div class="clearfix"></div>
                    <date-picker type="date" input-class="form-control"
                                 name="activation_end" v-model="value.activation_end" lang="en"
                                 v-bind:class="{'has-error' : errors.has('activation_end')}"
                                 format="YYYY-MM-DD" value-type="YYYY-MM-DD" placeholder="Activation End"/>
                    <div class="help text-danger" v-show="errors.has('activation_end')">
                      {{ errors.first("activation_end") }}
                    </div>
                  </div>

                  <div class="form-group ">
                    <!-- <label class="control-label">Is Synced</label>-->
                    <select class="form-control"
                            name="is_synced" v-model="value.is_synced" id="is_synced" hidden>
                      <option value="no">No</option>
                      <option value="yes">Yes</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "GlobalDiscountPricingForm",
  metaInfo: {
    title: "Global Discount Pricing | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {


    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/global_discount_pricings";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/global_discount_pricings/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "GlobalDiscountPricingList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/global_discount_pricings/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>

